module.exports = __webpack_public_path__ + "static/icons/sorprendido.b7ae225.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/characters/sorprendido.svg
// module id = AS4D
// module chunks = 1